import React from "react";
import { Stack, Title } from "@mantine/core";
import {
  ConnectAccountManagement,
  ConnectDocuments,
  ConnectNotificationBanner,
} from "@stripe/react-connect-js";

function Settings() {
  return (
    <Stack spacing="md" p="md">
      <ConnectNotificationBanner
        collectionOptions={{
          fields: "eventually_due",
          futureRequirements: "include",
        }}
      />
      <Title order={3}>Account Management</Title>
      <ConnectAccountManagement
        collectionOptions={{
          fields: "eventually_due",
          futureRequirements: "include",
        }}
      />

      <Title order={3} mt="md">
        Documents
      </Title>
      <ConnectDocuments />
    </Stack>
  );
}

export default Settings;
